import Component from "@tunnel-components/@pages/tools/extractor/home/component";
import * as React from "react";
import { connect } from "react-redux";
import {
  ExtractorVideoActionCreator,
  ExtractorCameraListActionCreator,
} from "@tunnel-store/index";
import * as Lodash from "lodash";
import { duration } from "moment";
import * as moment from "moment";
import * as Utils from "@Cyclope-Utils/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onStartDateChange
 * @name onEndDateChange
 * @name onStartTimeChange
 * @name onEndTimeChange
 * @name onSubmit
 * @name onChange
 * @name
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  //  faire cette action toute les 10 millisecondes
  // public debounceSubmit = Lodash.debounce((): void =>{}, 10)
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * @property { boolean }      state.btnloading
     * @property { string  }      state.enDate
     * @property { string  }      state.startDate
     * @property { number  }      state.selectedCamera
     * @property { boolean }      state.error
     * @property { boolean }      state.errorserver
     * @property { boolean }      state.loading
     * @property { boolean }      state.success
     * @property { boolean }      state.warning
     */
    this.state = {
      btnloading: false,
      cameraIderror: false,
      endDate: "",
      error: false,
      errorserver: false,
      isVisible: false,
      loading: false,
      searchCamera: null,
      selectedCamera: "",
      selectedOption: [],
      // startDate: "",
      success: false,
      warning: false,
      warningSevenDay: false,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onSubmit = this.onSubmit.bind(this);
    this.onEndDateChange = this.onEndDateChange.bind(this);
    this.onStartDateChange = this.onStartDateChange.bind(this);
    this.onGetIdentifiantItem = this.onGetIdentifiantItem.bind(this);
  }
  /**
   * MAJ des données
   * @method onSubmit
   * @param { React.ChangeEvent<HTMLInputElement>  }  event
   * @infos "https://reactjs.org"
   */
  public onSubmit = (event: any): void => {
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    {
      /** vérification de l'existence de l'élement  */
    }
    if (
      !Lodash.isEmpty(this.state.startDate) &&
      !Lodash.isEmpty(this.state.endDate) &&
      !Lodash.isUndefined(this.state.selectedCamera)
    ) {
      {
        /** comparaison */
      }
      if (this.state.endDate > this.state.startDate) {
        {
          /** vérification de l'existence de l'élement  */
        }
        if (Utils.limitDays(this.state.startDate, 10)) {
          if (
            Lodash.isNumber(this.state.selectedCamera) &&
            !Lodash.isNull(this.state.selectedCamera)
          ) {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any): any => ({
              loading: true,
              error: false,
              warning: false,
              warningSevenDay: false,
              cameraIderror: false,
            }));
            /**
             * @constant
             * @name startDateTime
             */
            const startDateTime = this.state.startDate;
            /**
             * @constant
             * @name endDateTime
             */
            const endDateTime = this.state.endDate;

            const offSetTime: any = new Date(startDateTime);
            /**
             * @constant
             * @name params
             */
            const params = {
              duration: Math.round(
                duration(endDateTime.diff(startDateTime)).asSeconds()
              ),
              selectedCamera: this.state.selectedCamera,
              // 'startDateTime': moment(startDateTime).format('YYYY-MM-DDTHH:mm:ss'),
              startDateTime: moment(startDateTime).format(),
              offSetTime: offSetTime.getTimezoneOffset() / 60,
              incidentId: null,
            };

            this.props
              .ExtractorVideoActionCreator(params)
              .then(() =>
                this.setState((state: any): any => ({ loading: false }))
              );
          } else {
            {
              /** Empêcher la mutation du state */
            }
            this.setState((state: any): any => ({ cameraIderror: true }));
          }
        } else {
          this.setState((state: any): any => ({ warningSevenDay: true }));
        }
      } else {
        this.setState((state: any): any => ({ warning: true }));
      }
    } else {
      if (
        Lodash.isEmpty(this.state.startDate) ||
        Lodash.isEmpty(this.state.endDate)
      ) {
        this.setState((state: any): any => ({ warning: true }));
      }
      if (
        Lodash.isUndefined(this.state.selectedCamera) ||
        !Lodash.isNumber(this.state.selectedCamera)
      ) {
        this.setState((state: any): any => ({ cameraIderror: true }));
      }
    }
  };
  /**
   * Changement des etats des inputs
   * @method onGetIdentifiantItem
   * @param { any }  value
   * @infos "https://reactdatepicker.com/"
   */
  public onGetIdentifiantItem = (value: any): void => {
    {
      /** comparaison de la variable */
    }
    if (!Lodash.isEqual(value, "eudes")) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        cameraIderror: false,
        error: false,
        selectedCamera: Number(value),
        success: false,
        warning: false,
        warningSevenDay: false,
      }));
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        cameraIderror: false,
        error: false,
        selectedCamera: "",
        success: false,
        warning: false,
        warningSevenDay: false,
      }));
    }
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      errorserver: false,
      loading: true,
      success: false,
      cameraIderror: false,
    }));
    {
      /** dispatch action */
    }
    this.props
      .ExtractorCameraListActionCreator()
      .then(() => this.setState((state: any): any => ({ loading: false })));
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** comparaison */
    }
    if (nextProps.errors !== this.props.errors) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.errors)) {
        this.setState((state: any): any => ({ error: true }));
      }
    } else if (nextProps.cameraError !== this.props.cameraError) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.cameraError)) {
        this.setState((state: any): any => ({ errorserver: true }));
      }
    } else if (nextProps.data !== this.props.data) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.data)) {
        this.setState((state: any): any => ({ success: true }));
      }
    } else if (nextProps.cameraList !== this.props.cameraList) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.cameraList)) {
        this.setState((state: any): any => ({
          selectedOptions: nextProps.cameraList,
        }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      btnloading: false,
      cameraIderror: false,
      error: false,
      errorserver: false,
      loading: false,
      success: false,
    }));
    // Stopper l'action une fois le component détruit
    // this.debounceSubmit.cancel();
  }
  /**
   * Changement des etats des inputs ( datepicker)
   * @method onStartDateChange
   * @param { any }  value
   * @infos "https://reactdatepicker.com/"
   */
  public onStartDateChange(value: any) {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      error: false,
      startDate: value,
      success: false,
      warning: false,
      warningSevenDay: false,
      cameraIderror: false,
    }));
  }
  /**
   * Changement des etats des inputs ( datepicker)
   * @method onEndDateChange
   * @param { any }  value
   * @infos "https://reactdatepicker.com/"
   */

  public onEndDateChange(value: any) {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      endDate: value,
      error: false,
      success: false,
      warning: false,
      warningSevenDay: false,
      cameraIderror: false,
    }));
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        onGetIdentifiantItem={this.onGetIdentifiantItem}
        onStartDateChange={this.onStartDateChange}
        onEndDateChange={this.onEndDateChange}
        onSubmit={this.onSubmit}
        {...this.props}
        {...this.state}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    cameraError: state.ExtractorCameraList.error,
    cameraList: state.ExtractorCameraList.data,
    data: state.ExtractorVideo.data,
    errors: state.ExtractorVideo.error,
    // loading: state.ExtractorVideo.loading
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  ExtractorVideoActionCreator,
  ExtractorCameraListActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/tools/extractor/home/container.tsx